<p class="card-text">Design and maintain robust server-side solutions for scalable systems.</p>
<ul>
    <li>Strong knowledge of Java/Kotlin</li>
    <li>Experience with RESTful APIs and databases</li>
    <li>Experience with Postgres and MongoDB</li>
    <li>Good Software Engineering Concepts</li>
</ul>
